import React from 'react';

function HomeIcon() {
	return (
		<svg
			viewBox="0 0 24 24"
			width="24"
			height="24"
			fill="currentColor"
			aria-hidden="true"
		>
			<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path>
		</svg>
	);
}

export default HomeIcon;
